module.exports = __webpack_public_path__ + "img/7.8ba75327.jpg";